import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prima-pagina',
  templateUrl: './prima-pagina.component.html',
  styleUrls: ['./prima-pagina.component.css']
})
export class PrimaPaginaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
